<template>
  <div class="classroom-info-container">
    <div class="info-item">教室基础信息</div>
    <a-form-model ref="classroomForm" :model="classroomForm" :rules="classroomFormRules">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item ref="classroomType" label="教室类型" prop="classroomType">
            <a-select
              v-model="classroomForm.classroomType"
              placeholder="请选择教室类型"
              style="width: 240px; margin-bottom: 10px"
              @change="handleChangeForm"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
              :disabled="pageType == 2 ? true : false"
            >
              <a-select-option
                :value="item.id"
                v-for="item in classroomTypeList"
                :key="item.name"
                @click="clickClassroomType(item)"
              >
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8" v-if="pageType == 2">
          <a-form-model-item ref="classroomCode" label="教室编号" prop="classroomCode">
            <a-input v-model="classroomForm.classroomCode" :disabled="true" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8" v-if="pageType != 2 && showClassroomCodeItem">
          <a-form-model-item ref="classroomCode" label="教室编号" prop="classroomCode">
            <a-input
              v-model="classroomForm.classroomCode"
              placeholder="非极简教室请输入教室编号"
              :disabled="pageType != 1 ? true : false"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="classroomName" label="教室名称" prop="classroomName">
            <a-input v-model="classroomForm.classroomName" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item ref="selectBuilding" label="所属楼栋" prop="selectBuilding">
            <a-cascader
              :options="buildingList"
              v-model="classroomForm.selectBuilding"
              placeholder="请选择所属楼栋"
              @change="onBuildingChange"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="longitude" label="教室坐标经度" prop="longitude">
            <a-input v-model="classroomForm.longitude" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="latitude" label="教室坐标纬度" prop="latitude">
            <a-input v-model="classroomForm.latitude" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="info-item">教室管理员</div>
    <a-form-model ref="classroomAdministrator" class="add-classroom-form" :model="classroomForm">
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item ref="administratorName" label="管理员姓名" prop="administratorName">
            <a-input v-model="classroomForm.administratorName" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="administratorPhone" label="管理员手机" prop="administratorPhone">
            <a-input v-model="classroomForm.administratorPhone" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="8">
          <a-form-model-item ref="maintainerName" label="维护人姓名" prop="maintainerName">
            <a-input v-model="classroomForm.maintainerName" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item ref="maintainerPhone" label="维护人手机" prop="maintainerPhone">
            <a-input v-model="classroomForm.maintainerPhone" @change="handleChangeForm" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <!-- <a-form-model-item ref="classroomName" label="导播人员" prop="classroomName">
        <a-input v-model="classroomForm.classroomName" />
      </a-form-model-item> -->
    </a-form-model>
    <div class="footer">
      <a-button type="primary" class="save-btn" @click="confirmSave">保存</a-button>
    </div>
  </div>
</template>

<script>
export default {
  async created() {
    // 标记保存状态
    localStorage.setItem('isSave', 0)
  },
  mounted() {
    localStorage.setItem('classroomInfo', JSON.stringify(this.classroomForm))
  },
  props: {
    classroomInfo: {
      type: Object
    },
    buildingList: {
      type: Array
    }
  },
  data() {
    let validateClassroomCode = (rule, value, callback) => {
      if (value === '' || !this.classroomForm.classroomCode) {
        callback(new Error('请输入教室编号'))
      } else {
        if (this.classroomForm.classroomCode && this.classroomForm.classroomCode.length != 12) {
          callback(new Error('教室编码为12位数字'))
        }
        callback()
      }
    }

    return {
      selectSchool: this.$route.query.selectSchool,
      pageType: this.$route.query.pageType,
      classroomForm: {
        schoolCode: '',
        classroomCode: '',
        buildingId: '',
        classroomName: '',
        classroomType: '',
        administratorName: '',
        administratorPhone: '',
        maintainerName: '',
        maintainerPhone: '',
        longitude: '',
        latitude: '',
        selectBuilding: []
      },
      classroomFormRules: {
        classroomCode: [{ required: true, message: '请输入教室编码', trigger: 'change' }],
        classroomName: [{ required: true, message: '请输入教室名称', trigger: 'blur' }],
        classroomType: [{ required: true, message: '请选择教室类型', trigger: 'blur' }],
        selectBuilding: [{ required: true, message: '请选择所属楼栋', trigger: 'change' }]
      },
      classroomTypeList: [
        {
          id: 1,
          name: '沉浸式教室'
        },
        {
          id: 12,
          name: '全景教室'
        },
        {
          id: 13,
          name: '极简教室'
        },
        {
          id: 14,
          name: '智慧教室'
        }
      ],
      showClassroomCodeItem: false
    }
  },
  watch: {
    classroomInfo: {
      handler: async function (nVal) {
        if (nVal) {
          this.classroomForm = JSON.parse(JSON.stringify(nVal))
        }
      },
      immediate: true
    }
  },
  methods: {
    onBuildingChange(value, selectOption) {
      // console.log('value, selectOption🔧:>>>>>>>', value, selectOption, 'classroomInfo.vue')
      this.classroomForm.selectBuilding = value
      this.classroomForm.buildingId = selectOption && selectOption.filter((item) => item.level == 2)[0]?.buildingId
      localStorage.setItem('lastClassroomInfo', JSON.stringify(this.classroomForm))
    },
    handleChangeForm() {
      localStorage.setItem('lastClassroomInfo', JSON.stringify(this.classroomForm))
    },
    clickClassroomType(item) {
      console.log('item🔧:>>>>>>>', item, 'classroomInfo.vue')
      if (item.id === 13) {
        this.classroomForm.classroomCode = ' '
        this.showClassroomCodeItem = false
      } else {
        this.showClassroomCodeItem = true
      }
    },
    confirmSave() {
      this.$refs.classroomForm.validate((valid) => {
        if (valid) {
          // 标记是否保存
          localStorage.setItem('isSave', 1)
          const {
            classroomCode,
            buildingId,
            classroomName,
            classroomType,
            administratorName,
            administratorPhone,
            maintainerName,
            maintainerPhone,
            longitude,
            latitude,
            id
          } = this.classroomForm
          let params = {
            buildingId: buildingId,
            classroomName: classroomName,
            classroomType: classroomType,
            administratorName: administratorName,
            administratorPhone: administratorPhone,
            maintainerName: maintainerName,
            maintainerPhone: maintainerPhone,
            longitude: longitude,
            latitude: latitude
          }
          if (this.pageType == 2) {
            params.id = id
          } else {
            params.schoolCode = this.selectSchool
            params.classroomCode = classroomCode

            if (params.classroomType != 13 && (params.classroomCode && params.classroomCode.length) !== 12) {
              return this.$message.warning('教室编码为12位数字,请重新填写')
            }
          }
          this.$emit('updateClassroomInfo', {
            type: this.pageType,
            params
          })
          // if (this.pageType == 1) {
          //   this.classroomForm = {
          //     buildingId: '',
          //     classroomName: '',
          //     classroomType: '',
          //     administratorName: '',
          //     administratorPhone: '',
          //     maintainerName: '',
          //     maintainerPhone: '',
          //     longitude: '',
          //     latitude: '',
          //     selectBuilding: []
          //   }
          // }
        } else {
          console.log('submitError🔧:>>>>>>>', 'classroomInfo.vue')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.classroom-info-container {
  font-size: 14px;
  height: 100%;
  position: relative;
  .info-item {
    margin-bottom: 22px;
    font-weight: 600;
    text-align: left;
    color: #1e2228;
  }
  .footer {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 100%;
    height: 77px;
    line-height: 76px;
    border-top: 1px solid #e7e7e7;
    .save-btn {
      line-height: 32px;
      border-color: #5f60d3;
      background-color: #5f60d3;
    }
  }
}
::v-deep .ant-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  .ant-row {
    width: 100%;
  }
  .ant-form-item {
    display: flex;
  }
  .ant-form-item-label {
    width: 110px;
    text-align: right;
  }

  .ant-form-item-control {
    width: 240px;
  }
  .ant-cascader-picker {
    text-align: left;
  }
  .has-error .ant-form-explain,
  .has-error .ant-form-split {
    text-align: left;
  }
}
</style>
